import Vue from 'vue'
import Router from 'vue-router'

import inicio from '@/pages/inicio'
import noticias from '@/pages/noticias'
import documentos from '@/pages/documentos'
import contenido from '@/pages/contenido'
// import estaractualizado from '@/pages/estaractualizado'
import directorio from '@/pages/directorio'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: inicio,
      name: 'inicio'
    },
    {
      path: '/noticias/:idCont/:catName',
      component: noticias,
      name: 'noticias'
    },
    {
      path: '/documentos/:nameFiltro',
      component: documentos,
      name: 'documentos'
    },
    {
      path: '/contenido/:idCont/:catName',
      component: contenido,
      name: 'contenido'
    },
    {
      path: '/documentos/Comunicados_Suministro_de_Agua', // estaractualizado
      component: documentos,
      name: 'estaractualizado'
    },
    {
      path: '/directorio',
      component: directorio,
      name: 'directorio'
    }
  ],
  scrollBehavior () {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' })
  }
})
